import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Businesses from "./pages/businesses";
import Drivers from "./pages/Drivers";
import ScrollToTop from "./components/ScrollToTop";
import EOI from "./pages/eoi";
import "./App.css"

export default function App() {

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/businesses" element={<Businesses />} />
        <Route path="/drivers" element={<Drivers />} />
        <Route path="/EOI" element={<EOI />} />
      </Routes>
    </BrowserRouter>
  );
}
